import { $ } from '../util/view';
import settings from './settings';
import { fetchNonRegisteredVendorList, fetchNonTCFRegisteredVendorList, } from '../service/vendor-list';
import alert from './alert';
import { postTrackingEvent } from '../util/tracking';
import { getAndRemoveItem } from '../util/storage';
const JUST_CONSENTED = (() => {
    try {
        return !!getAndRemoveItem('mol.ads.cmp.alert');
    }
    catch (error) {
        return false;
    }
})();
export default async function render({ api, applicableRegulations, banner, hasChoiceBeenMade, hasTPhrase, renderSettings = true, t, translate, clientConsentString, forceSetConsentString, renderConfig, pVendorList, cvlUiVersion, nrvUiVersion, vendorListBaseUrl, isEmbeddedVideo, infoSvg, shouldConsentManagementBeEnforced, }) {
    const consentAlert = alert({
        message: 'Great! Thanks for choosing the best browsing experience. You can change your privacy settings at any time from our Privacy Policy.',
        onClose: () => {
            consentAlert.remove();
        },
    });
    const dissentAlert = alert({
        message: translate('banner.alert.optOut'),
        onClose: () => {
            dissentAlert.remove();
        },
    });
    const toggleSettings = (event) => {
        event.preventDefault();
        if (app.raw.classList.contains('mol-ads-cmp--settings-open')) {
            document.documentElement.classList.remove('mol-ads-cmp--open');
        }
        app.raw.classList.toggle('mol-ads-cmp--settings-open');
    };
    const consentToAll = (event) => {
        event.preventDefault();
        api.consentToAll();
    };
    const dissentToAll = (event) => {
        event.preventDefault();
        api.dissentToAll();
    };
    const showConsentAlert = () => {
        app.appendChild(consentAlert);
    };
    const getUSPData = () => {
        // @ts-ignore
        return api.callP('getUSPData');
    };
    const loadAndRenderSettings = async (pVendorList) => {
        if (renderSettings) {
            const [vendorList, nonTCFRegisteredVendors, nonRegisteredVendors] = await Promise.all([
                pVendorList,
                fetchNonTCFRegisteredVendorList(vendorListBaseUrl, cvlUiVersion),
                fetchNonRegisteredVendorList(vendorListBaseUrl, nrvUiVersion),
            ]);
            const opts = Object.assign({}, options, {
                applicableRegulations,
                nonTCFRegisteredVendors,
                nonRegisteredVendors,
                vendorList: vendorList,
                renderConfig,
            });
            const settingsModal = settings(opts);
            app.appendChild(settingsModal);
            renderSettings = false;
        }
    };
    const showDissentAlert = () => {
        app.appendChild(dissentAlert);
    };
    const showAlert = async (consent) => {
        if (typeof consent === 'undefined') {
            consent = (await api.callP('hasConsentedToAll'));
        }
        if (consent) {
            showConsentAlert();
        }
        else {
            showDissentAlert();
        }
    };
    const options = {
        api,
        hasChoiceBeenMade,
        hasTPhrase,
        onAccept: isEmbeddedVideo
            ? [
                consentToAll,
                toggleSettings,
                () => {
                    const video = document.body.querySelector('[id^="vjs_video"]') ||
                        document.body.querySelector('[data-opts]') ||
                        document.body.querySelector('video');
                    if (video && video.player) {
                        video.player.play();
                    }
                },
            ]
            : [consentToAll],
        onCloseSettings: [toggleSettings],
        onDecline: [dissentToAll],
        onOpenSettings: [
            toggleSettings,
            () => postTrackingEvent('overlay open settings'),
            async () => {
                loadAndRenderSettings(pVendorList);
            },
        ],
        t,
        translate,
        infoSvg,
        shouldConsentManagementBeEnforced,
    };
    const parts = banner ? [banner(options)] : [];
    const shakeCookieBanner = async (e) => {
        const t = e.target;
        const banner = document.getElementsByClassName('mol-ads-cmp')[0];
        banner.style.animationName = '';
        if (t.classList.contains('mol-ads-cmp')) {
            await new Promise((r) => setTimeout(r, 0));
            const animationType = location.search.match(/ac.cmp.animation=(\w+)/);
            banner.style.animationName = `${animationType ? animationType[1] : 'shake'}`;
        }
    };
    const app = $('div', {
        class: 'mol-ads-cmp',
        'data-cmp-no-consent': true,
    }, parts)
        .on('mousedown', shakeCookieBanner)
        .on('touchstart', shakeCookieBanner);
    if (applicableRegulations.includes('ccpa')) {
        window.document.documentElement.classList.add('ccpa');
    }
    const hideBannerOnsScroll = () => document.documentElement.classList.remove('mol-ads-cmp--open');
    if (!hasChoiceBeenMade || forceSetConsentString) {
        const CONSENT = '1YNN';
        const DISSENT = '1YYN';
        const NOT_APPLICABLE = '1---';
        if (clientConsentString &&
            [CONSENT, DISSENT, NOT_APPLICABLE].includes(clientConsentString)) {
            if (clientConsentString === CONSENT) {
                api.consentToAll(location.origin);
            }
            else if (clientConsentString === DISSENT) {
                api.dissentToAll(location.origin);
            }
            else {
                api.setCCPANotApplicableStatus([location.origin, 'unknown']);
            }
        }
        else if (shouldConsentManagementBeEnforced) {
            const scrollableContent = [
                window,
                document.querySelector('.scrollable-content'),
            ].filter((el) => el);
            scrollableContent.forEach((el) => el.addEventListener('scroll', hideBannerOnsScroll));
            api.consentToAll(location.origin);
            postTrackingEvent('overlay displayed');
            document.documentElement.classList.add('mol-ads-cmp--open');
        }
        else {
            api.setCCPANotApplicableStatus([
                location.origin,
                window.PageCriteria.channel,
            ]);
        }
    }
    else {
        if (shouldConsentManagementBeEnforced &&
            /$1--/.test((await getUSPData()).uspString)) {
            // If we previously thought CCPA doesn't apply but we see a visitor now in CA,
            // we start complying with it
            postTrackingEvent('overlay displayed');
            document.documentElement.classList.add('mol-ads-cmp--open');
            api.consentToAll(location.origin);
        }
        if ((await getUSPData()).uspString === '1N--') {
            api.setCCPANotApplicableStatus([
                location.origin,
                window.PageCriteria.channel,
            ]);
        }
        options.onAccept.push(showConsentAlert);
        options.onDecline.push(showDissentAlert);
        if (JUST_CONSENTED) {
            showAlert();
        }
    }
    api.on('thanksGiven', () => {
        document.documentElement.classList.remove('mol-ads-cmp--open');
    });
    return Object.assign(app, {
        alert: showAlert,
        openSettings: async () => {
            if (shouldConsentManagementBeEnforced) {
                app.raw.classList.add('mol-ads-cmp--settings-open');
                postTrackingEvent('overlay open settings');
                loadAndRenderSettings(pVendorList);
            }
        },
        closeSettings: () => {
            document.documentElement.classList.remove('mol-ads-cmp--open');
        },
    });
}
